import { isNotNull } from '@ramp106/omrjs-common'
import { type RouteLocationNormalized } from 'vue-router'

import { TimeFrameOptionsEnum } from '@/components/ReviewsManagement/Reviews/types'
import { RecommendationRatingKeyEnum, UniversalReviewStates } from '@/gql/reviews'
import { checkEnumValue } from '@/helpers/checkEnumValue'
import { getQueryStringArrayValue } from '@/helpers/getQueryStringArrayValue'

export interface AgencyReviewsFilters {
  timeframe: TimeFrameOptionsEnum
  ratings: RecommendationRatingKeyEnum[]
  states: UniversalReviewStates[]
}

export const agencyReviewsFiltersFromQuery = (query: RouteLocationNormalized['query']): AgencyReviewsFilters => {
  const { timeframe, rating, state } = query

  return {
    timeframe: checkEnumValue(timeframe, TimeFrameOptionsEnum, TimeFrameOptionsEnum.NONE),
    ratings: getQueryStringArrayValue(rating)
      .map((value) => checkEnumValue(value, RecommendationRatingKeyEnum, null))
      .filter(isNotNull),
    states: getQueryStringArrayValue(state)
      .map((value) => checkEnumValue(value, UniversalReviewStates, null))
      .filter(isNotNull),
  }
}
